import { StanBadge } from '@/components';
import type { Booking } from '../../types/appointment.types';

interface OverviewProps {
    booking: Booking;
}

export function Overview({ booking }: OverviewProps) {
    // Get status string matching Vue logic
    const getStatusString = (bookingStatus: number) => {
        if (bookingStatus === 0) {
            return 'Cancelled';
        }
        return '';
    };

    const status = getStatusString(booking.booking_status);
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    };

    const formatTime = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };

    return (
        <div className='flex flex-col gap-6'>
            <div className='grid grid-cols-1 gap-6 sm:grid-cols-2'>
                <div className='flex flex-col gap-1'>
                    <label className='text-gray text-sm font-medium'>Date</label>
                    <span className='text-dark text-base'>{formatDate(booking.start)}</span>
                </div>
                <div className='flex flex-col gap-1'>
                    <label className='text-gray text-sm font-medium'>Slot</label>
                    <span className='text-dark text-base'>
                        {formatTime(booking.start)} - {formatTime(booking.end)}
                    </span>
                </div>
            </div>

            <div className='flex flex-col gap-1'>
                <label className='text-gray text-sm font-medium'>Title</label>
                <div className='flex flex-nowrap items-center'>
                    <span className='text-dark truncate text-base'>{booking.title}</span>&nbsp;
                    {status && (
                        <StanBadge variant='destructive' size='sm' className='flex-shrink-0'>
                            {status}
                        </StanBadge>
                    )}
                </div>
            </div>

            {booking.meeting_link && (
                <div className='flex flex-col gap-1'>
                    <label className='text-gray text-sm font-medium'>Link</label>
                    <a
                        href={booking.meeting_link}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-brand-main hover:text-brand-pressed text-sm transition-colors'
                    >
                        {booking.meeting_link}
                    </a>
                </div>
            )}
        </div>
    );
}
